import { render, staticRenderFns } from "./16zhihuidangjian.vue?vue&type=template&id=d38bfc3e&scoped=true&"
import script from "./16zhihuidangjian.vue?vue&type=script&lang=js&"
export * from "./16zhihuidangjian.vue?vue&type=script&lang=js&"
import style0 from "./16zhihuidangjian.vue?vue&type=style&index=0&id=d38bfc3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38bfc3e",
  null
  
)

export default component.exports